
import { Component, Vue } from 'vue-property-decorator'

@Component({})

export default class NotFoundVue extends Vue {
  private image: string = './img/GlitchedLogo_BiColor2_sml.png'
}
